import { logger } from '@/logging/logger'

export default {
    async reset({ commit }) {
        logger.info('auth', 'session.reset', undefined, 'Session reset initiated').then();
        commit('reset')
    },
    resume({ commit }, payload) {
        commit('resume', payload)
    },
    async login({ getters, dispatch }, payload) {
        logger.info('auth', 'session.login', undefined, 'Session login initiated').then();
        let now = new Date()
        now.setMonth(now.getMonth() + 12)
        document.cookie = `session=${encodeURIComponent(payload)};expires=${now}`
        logger.info('auth', 'session.cookie.set', undefined, 'Session cookie set').then();
        document.location.href = '/'
    },
    async logout() {
        logger.info('auth', 'session.logout', undefined, 'Session logout initiated').then();

        // Clear all session-related cookies
        document.cookie.split(";").forEach(c => document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/"));

        // Clear local storage
        try {
            localStorage.clear()
        } catch (error) {
            logger.error('storage', 'storage.key.failure', { key: 'localStorage', operation: 'clear', message: error?.message }, 'Failed clearing localStorage during logout').then();
        }

        // Clear session storage
        try {
            sessionStorage.clear()
        } catch (error) {
            logger.error('storage', 'storage.key.failure', { key: 'sessionStorage', operation: 'clear', message: error?.message }, 'Failed clearing sessionStorage during logout').then();
        }

        // Clear cache storage
        try {
            const cacheNames = await caches.keys()
            await Promise.all(cacheNames.map(name => caches.delete(name)))
        } catch (error) {
            logger.error('storage', 'storage.key.failure', { key: 'cacheStorage', operation: 'clear', message: error?.message }, 'Failed clearing cache storage during logout').then();
        }

        document.location.href = '/'
    },
    async start({ commit, dispatch }) {
        commit('start')
        dispatch('v4/geo/getPosition', null, { root: true })
    }
}
